<template>
  <v-flex lg8 sm10 xs12 mb-10 pb-5>
    <v-layout justify-end align-end>
      <p class="title mb-0 pb-0 mt-3">Conteúdos do capítulo</p>
      <v-spacer />
      <v-btn class="" small @click="ordererDialog = true" color="primary">Reordenar</v-btn>
    </v-layout>
    <lister
      style="height: 100%"
      :items="shownContents || []"
      cardBreakpoints="xs12 md6 xl4"
      searchPlaceholder="Buscar por título"
      :customSearchFunction="search"
      emptyListMessage="Nenhum conteúdo cadastrado..."
      emptySearchMessage="Nenhum conteúdo encontrado..."
      :autosort="false"
    >
      <template v-slot:default="slotProps">
        <content-tile
          class="ma-1"
          :content="slotProps.item"
          :index="slotProps.index"
          @didTapItem="didTapItem"
        />
      </template>
    </lister>
    <content-speed-dial :currentContents="shownContents" :showsReorder="shownContents.length > 0" />
    <default-dialog v-model="ordererDialog">
      <orderer :originalArray="shownContents" @arrayReordered="arrayReordered">
        <template v-slot:default="slotProps">
          <content-tile
            :content="slotProps.item"
            :index="slotProps.index"
          />
        </template>
      </orderer>
      <template slot="rightButton">
        <v-btn @click="didTapSaveReorder" text>Salvar</v-btn>
      </template>
    </default-dialog>
  </v-flex>
</template>

<script>
import { contentCollectionRef } from "@/firebase/api/content";
import { updateChapter } from "@/firebase/api/chapter";
import Lister from "@/components/Lister";
import ContentSpeedDial from "./speedDial";
import ContentTile from "@/components/contents/Tile";
import Orderer from "@/components/Orderer";
import DefaultDialog from "@/components/dialogs/Default";

export default {
  components: {
    Lister,
    ContentTile,
    ContentSpeedDial,
    Orderer,
    DefaultDialog
  },
  props: {
    chapter: Object
  },
  mounted() {
    this.$bind("contents", contentCollectionRef(this.$route.params.chapterID));
  },
  data: () => ({
    ordererDialog: false,
    contents: [],
    reorderedContents: []
  }),
  methods: {
    arrayReordered(newArray) {
      
      // console.log('newArray')
      // console.log(newArray)
      this.reorderedContents = newArray.map(value => value.id);
      // console.log('this.reorderedContents')
      // console.log(this.reorderedContents)
    },
    didTapSaveReorder() {
      this.ordererDialog = false;
      updateChapter(this.$route.params.chapterID, {
        contentOrder: this.reorderedContents
      });
    },
    didTapItem(item) {
      this.$router.push({
        name: "content",
        params: { chapterID: this.$route.params.chapterID, contentID: item.id }
      });
    }
  },
  computed: {
    search() {
      return (item, searchString) =>
        item.title.toLowerCase().includes(searchString.toLowerCase());
    },
    shownContents() {
      if (this.chapter == null) {
        return [];
      }
      let shown = this.contents.slice();
      shown.sort(this.sortContents);
      // console.log('shown')
      // console.log(shown)
      // console.log('this.contents')
      // console.log(this.contents)
      return shown;
    },
    sortContents() {
      return (a, b) => {
        let contentOrder = this.chapter.contentOrder || [];
        let indexA = contentOrder.indexOf(a.id);
        let indexB = contentOrder.indexOf(b.id);
        return indexA - indexB;
      };
    }
  }
};
</script>
